<template>
    <div>
        <v-dialog
            v-model="showDialog"
            width="700"
            persistent
        >
            <v-card>
                <v-form
                    ref="form"
                    v-model="form"
                    @submit.prevent="submitForm"
                >
                    <v-card-title style="background-color: #009688; color: white; word-wrap: normal;">
                        Generate Endorsement and Confirmation
                    </v-card-title>
                    <v-card-text
                        :loading="loading"
                        class="dialogContainer"
                        style="max-height: 70vh; overflow-y: scroll; background-color: #EDFFFB;"
                    >
                        <FormPage
                            :endorsement-data="endorsementData"
                            @doneClearField="clearField = false"
                            @showSelectedMember="showSelectedMember.temporary = true"
                        />
                    </v-card-text>
                    <v-card-actions style="background-color: #EDFFFB;">
                        <v-spacer />
                        <v-btn
                            outlined
                            class="white--text"
                            color="teal darken-1"
                            style="text-transform: none; width: 105px;"
                            @click="closeAllDialog"
                        >
                            CLOSE
                        </v-btn>
                        <v-btn
                            type="submit"
                            color="teal darken-1 white--text"
                            class="white--text"
                            style="text-transform: none; width: 105px; font-weight: 600"
                            :disabled="!endorsementData.CREATE_CON && !endorsementData.CREATE_END"
                            :loading="loading"
                        >
                            GENERATE
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <DisplaySelected
            :show="showSelectedMember.temporary"
            :selected="selected"
            @closeDialog="showSelectedMember.temporary = false"
            @addSelection="addSelectionFunc"
            @temporaryDueAdd="temporaryDueAddFunc"
        />
        <PdfViewer
            :data="generateEndorsementConfirmationData && generateEndorsementConfirmationData.data"
            :endorsement-data="endorsementData"
            :show="showGenerateEndorsementConfirmationData"
            :screen_width="screen_width"
            :notif="notif"
            @closePdfViewer="showGenerateEndorsementConfirmationData = false"
        />
    </div>
</template>

<script>
import PdfViewer from './PdfViewer.vue'
import DisplaySelected from './DisplaySelected.vue'
import FormPage from './FormPage.vue'
import { mapGetters, mapActions } from 'vuex'
import { moment } from '../../../../../../utils/date-shim'

export default {
    components: { FormPage, DisplaySelected, PdfViewer },
    props: ['show', 'selected', 'notif'],
    data: () => ({
        tempFormData: null,
        selectedClinic: null,
        showGenerateEndorsementConfirmationData: false,
        loading: false,
        form: false,
        endorsementData: {
            'CREATE_END': true,
            'CREATE_CON': true,
            'ACU_ACCT_N': null,
            'ACU_ACCOUNT': null,
            'ACU_START': null,
            'ACU_END': null,
            'ACU_MEMB': [],
            'ACU_COMPANY': null,
            'TO_PREFIX_END': null,
            'TO_FNAME_END': null,
            'TO_SNAME_END': null,
            'TO_SUFFIX_END': null,
            'TO_DESIGNATION_END': null,
            'INCLUDED_INFO_END': [
                { 'included': true, 'title': 'Account Name', 'column': 'ACCT_M' },
                { 'included': true, 'title': 'MemNo', 'column': 'MEMB_N' },
                { 'included': true, 'title': 'Member Name', 'column': 'LAST_M' },
                { 'included': true, 'title': 'Paid Until', 'column': 'PDUN_D' },
                { 'included': false, 'title': 'Birthday', 'column': 'BIRT_D' },
                { 'included': true, 'title': 'Age', 'column': 'AGE' },
                { 'included': true, 'title': 'EffD', 'column': 'STRT_D' },
                { 'included': true, 'title': 'Gender', 'column': 'SEX' }
            ],
            'INCLUDED_INFO_CON': [
                { 'included': true, 'title': 'Account Name', 'column': 'ACCT_M' },
                { 'included': true, 'title': 'MemNo', 'column': 'MEMB_N' },
                { 'included': true, 'title': 'Member Name', 'column': 'LAST_M' },
                { 'included': true, 'title': 'Paid Until', 'column': 'PDUN_D' },
                { 'included': true, 'title': 'Birthday', 'column': 'BIRT_D' },
                { 'included': true, 'title': 'Age', 'column': 'AGE' },
                { 'included': true, 'title': 'EffD', 'column': 'STRT_D' },
                { 'included': true, 'title': 'Gender', 'column': 'SEX' }
            ],
            'TO_PREFIX_CON': null,
            'TO_FNAME_CON': null,
            'TO_SNAME_CON': null,
            'TO_SUFFIX_CON': null,
            'TO_DESIGNATION_CON': null,
            'ACU_CLINIC': null,
            'ACU_SCHEDULE': null,
            'ACU_CONTACT_PERSON': null,
            'ACU_CLINIC_TELNO': null,
            'ACU_MSU_CODE': null,
            'CONFIRMATION_ADDITIONAL_CLAUSE': 'Additional examinations or procedures other than the package specified above will be directly charged to your account.',
            'SAVE': false,
            'ACU_LETTER_LIMIT_START': null,
            'ACU_LETTER_LIMIT_END': null,
            'IS_CON_ADDR_MEMBER': false,
            'REFERENCE_TOKEN' : null
        },
        showSelectedMember: {
            temporary: false,
            permanent: false,
            temporaryDueAdd: false
        },
        screen_width: document.documentElement.clientWidth + 9
    }),
    computed: {
        ...mapGetters(['getStatusProvisionData', 'generateEndorsementConfirmationData', 'generateQualifiedListData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        generateEndorsementConfirmationData(newVal) {
            if (newVal.status === 200) {
                this.showGenerateEndorsementConfirmationData = true
            } else {
                this.notif.type = 'error'
                this.notif.color = 'error'
                this.notif.timeout = 5000
                this.notif.msg = newVal.state
                this.notif.show = true
            }
            this.loading = false
        },
        selected: {
            handler(newVal) {
                this.endorsementData.ACU_MEMB = []
                for (let i=0; i<this.selected.length; i++) {
                    this.endorsementData.ACU_MEMB.push(this.selected[i].MEMB_N)
                }
                if (newVal && newVal.length < 1) {
                    this.closeAllDialog()
                }
            },
            deep: true,
            immediate: true
        },
        'showSelectedMember.permanent'(newVal) {
            if (newVal) {
                if (this.$refs && this.$refs.form) {
                    this.$refs.form.reset()
                    this.$nextTick(()=>{
                        this.endorsementData.CREATE_END = true
                        this.endorsementData.CREATE_CON = true
                        this.endorsementData.INCLUDED_INFO_END = [
                            { 'included': true, 'title': 'Account Name', 'column': 'ACCT_M' },
                            { 'included': true, 'title': 'MemNo', 'column': 'MEMB_N' },
                            { 'included': true, 'title': 'Member Name', 'column': 'LAST_M' },
                            { 'included': true, 'title': 'Paid Until', 'column': 'PDUN_D' },
                            { 'included': false, 'title': 'Birthday', 'column': 'BIRT_D' },
                            { 'included': true, 'title': 'Age', 'column': 'AGE' },
                            { 'included': true, 'title': 'EffD', 'column': 'STRT_D' },
                            { 'included': true, 'title': 'Gender', 'column': 'SEX' }
                        ]
                        this.endorsementData.INCLUDED_INFO_CON = [
                            { 'included': true, 'title': 'Account Name', 'column': 'ACCT_M' },
                            { 'included': true, 'title': 'MemNo', 'column': 'MEMB_N' },
                            { 'included': true, 'title': 'Member Name', 'column': 'LAST_M' },
                            { 'included': true, 'title': 'Paid Until', 'column': 'PDUN_D' },
                            { 'included': true, 'title': 'Birthday', 'column': 'BIRT_D' },
                            { 'included': true, 'title': 'Age', 'column': 'AGE' },
                            { 'included': true, 'title': 'EffD', 'column': 'STRT_D' },
                            { 'included': true, 'title': 'Gender', 'column': 'SEX' }
                        ]
                        this.endorsementData.CONFIRMATION_ADDITIONAL_CLAUSE = 'Additional examinations or procedures other than the package specified above will be directly charged to your account.'
                        this.endorsementData.REFERENCE_TOKEN = null
                    })
                }
            }
        },
        show(newVal) {
            if (newVal) {
                this.$nextTick(async () => {
                    if (this.showSelectedMember.temporaryDueAdd) {
                        this.showSelectedMember.temporary = true
                    }
                    this.showSelectedMember.permanent = false
                    await this.getItemData()
                })
            }
        }
    },
    methods: {
        ...mapActions(['getStatusProvision', 'generateEndorsementConfirmation']),
        temporaryDueAddFunc(show) {
            this.showSelectedMember.temporaryDueAdd = show
        },
        addSelectionFunc() {
            this.showSelectedMember.temporary = false
            this.showDialog = false
        },
        closeAllDialog() {
            this.showDialog = false
            this.showSelectedMember = {
                temporary: false,
                permanent: true
            }
        },
        submitForm() {
            this.$nextTick(() => {
                if (this.$refs && this.$refs.form.validate()) {
                    this.loading = true
                    this.endorsementData.REFERENCE_TOKEN = this.generateQualifiedListData.data.reference
                    this.generateEndorsementConfirmation(this.endorsementData)
                } else {
                    this.$nextTick(() => {
                        const errorEl = document.querySelector('.dialogContainer .v-messages.error--text:first-of-type')
                        if (errorEl) {
                            this.$vuetify.goTo(errorEl, {
                                container: '.dialogContainer',
                                duration: 300,
                                offset: 50
                            })
                        }
                    })
                }
            })
        },
        mergeDataFunc(newVal) {
            this.$nextTick(() => {
                this.endorsementData = { newVal }
            })
        },
        isValidDate(dateString) {
            if (dateString instanceof Date && !isNaN(dateString)) {
                return true
            } else if (dateString && String(dateString).trim()) {
                const date = new Date(dateString)
                return date instanceof Date && !isNaN(date)
            } else {
                return false
            }
        },

        async getItemData() {
            this.loading = true
            if (this.selected && this.selected.length > 0) {
                await this.getStatusProvision({ ACCT_N: this.selected[0].ACCT_N })
                const acct = this.getStatusProvisionData.data
                if (acct) {
                    this.endorsementData.ACU_ACCT_N = this.selected[0].ACCT_N
                    this.endorsementData.ACU_ACCOUNT = this.selected[0].ACCT_M
                    // this.endorsementData.ACU_START =  acct.STATUS_DATE
                    // this.endorsementData.ACU_END = acct.ACTIVE_UNTIL
                    this.endorsementData.ACU_START = this.isValidDate(acct.STATUS_DATE) ? moment(acct.STATUS_DATE).utcOffset('+0800').startOf('day').format('YYYY-MM-DD') : null
                    this.endorsementData.ACU_END = this.isValidDate(acct.ACTIVE_UNTIL) ? moment(acct.ACTIVE_UNTIL).utcOffset('+0800').startOf('day').format('YYYY-MM-DD') : null
                    this.endorsementData.ACU_LETTER_LIMIT_START = this.isValidDate(acct.STATUS_DATE) ? moment(acct.STATUS_DATE).utcOffset('+0800').startOf('day').format('YYYY-MM-DD') : null
                    this.endorsementData.ACU_LETTER_LIMIT_END = this.isValidDate(acct.ACTIVE_UNTIL) ? moment(acct.ACTIVE_UNTIL).utcOffset('+0800').startOf('day').format('YYYY-MM-DD') : null
                }
            }
            this.loading = false
        }
    }
}
</script>
